/**
 * Hex Math Library - Type Definitions
 *
 * Core type definitions for hexagonal grid mathematics.
 * Supports axial, cube, and pixel coordinate systems.
 */
/**
 * Direction vectors for hex neighbors
 */
export var HexDirection;
(function (HexDirection) {
    HexDirection[HexDirection["NE"] = 0] = "NE";
    HexDirection[HexDirection["E"] = 1] = "E";
    HexDirection[HexDirection["SE"] = 2] = "SE";
    HexDirection[HexDirection["SW"] = 3] = "SW";
    HexDirection[HexDirection["W"] = 4] = "W";
    HexDirection[HexDirection["NW"] = 5] = "NW"; // North-West
})(HexDirection || (HexDirection = {}));
/**
 * Convert degrees from atan2(dr, dq) in axial coordinate space to HexDirection.
 *
 * The backend computes facing direction as:
 *   Math.atan2(target.r - source.r, target.q - source.q) * (180 / Math.PI)
 *
 * Axial hex neighbor vectors produce these angles:
 *   E  (+1, 0) →   0°     NE (+1,-1) → -45°
 *   SE ( 0,+1) →  90°     NW ( 0,-1) → -90°
 *   SW (-1,+1) → 135°     W  (-1, 0) → ±180°
 *
 * We partition the full circle at midpoints between consecutive directions.
 */
export function degreesToHexDirection(degrees) {
    // Normalize to [0, 360)
    const normalized = ((degrees % 360) + 360) % 360;
    // Boundaries (midpoints between adjacent direction angles):
    //   E(0°) ↔ SE(90°):   midpoint = 45°
    //   SE(90°) ↔ SW(135°): midpoint = 112.5°
    //   SW(135°) ↔ W(180°): midpoint = 157.5°
    //   W(180°) ↔ NW(270°): midpoint = 225°
    //   NW(270°) ↔ NE(315°): midpoint = 292.5°
    //   NE(315°) ↔ E(360°): midpoint = 337.5°
    if (normalized < 45)
        return HexDirection.E;
    if (normalized < 112.5)
        return HexDirection.SE;
    if (normalized < 157.5)
        return HexDirection.SW;
    if (normalized < 225)
        return HexDirection.W;
    if (normalized < 292.5)
        return HexDirection.NW;
    if (normalized < 337.5)
        return HexDirection.NE;
    return HexDirection.E; // 337.5° - 360° wraps back to E
}
//# sourceMappingURL=types.js.map